__turbopack_context__.v({
  "dark": "ThemeImage-module-scss-module__FSK1oW__dark",
  "light": "ThemeImage-module-scss-module__FSK1oW__light",
});
